export const initialLogInForm = {
  email: "",
  password: "",
};
